import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridOptions, GridReadyEvent } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs/Subscription';
import {ReservationService} from '../../reservations.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { PlanService } from 'app/core/services/plan.service';

@Component({
  selector: 'app-encounter-history',
  templateUrl: './encounter-history.component.html',
  styleUrls: ['./encounter-history.component.scss'],
})
export class EncounterHistoryComponent implements OnInit, OnDestroy {
  protected grid: GridOptions;
  private suscriptions: Subscription[] = [];
  protected encounterData: any;
  protected tripId: number;

  constructor(
    private _reservationService: ReservationService,
    private _sweetAlertHelper: SweetAlertHelper,
    private loading: T2LoadingService,
    private planService: PlanService
  ) {
    this.createGrid();
  }

  ngOnInit() {
    this.observables();
  }

  observables() {
    this.suscriptions.push(
      this._reservationService.modelEncounter$.subscribe({
        next: (data) => {
          if (data) {
            this.tripId = data.tripId;
            this.encounterData = data;
            if (data.tripId) {
              this.getEncounterHistory(this.tripId);
            }
          }
        },
      }),
      this.planService.changeReservationPlanTypeAndRegion.subscribe({
        next: (data) => {
          if (data) {
            this.setReservationPlanTypeAndRegion();
          }
        }, error: (err) => {
          this._sweetAlertHelper.captureException(err);
        }
      }),
    );
  }

  getEncounterHistory(tripId: number) {
    this.suscriptions.push(
      this._reservationService
        .getEncounterHistoryByTripId(tripId)
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.grid.api.setRowData(data);
            }
          },
          error: (error: any) => {
            this._sweetAlertHelper.captureException(error);
          },
        })
    );
  }

  private createGrid() {
    this.grid = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          headerName: 'Date',
          field: 'dateformatted',
        },
        {
          headerName: 'File Name',
          field: 'filename',
        },
        {
          headerName: 'File Type',
          field: 'filetype',
        },
        {
          headerName: 'Status ',
          field: 'status',
        },
        {
          headerName: 'Reason ',
          field: 'rejectedreason',
        },
      ],
      onGridReady: () => {
        this.grid.api.sizeColumnsToFit();
        this.grid.api.setRowData([]);
      },
    };
  }

  setReservationPlanTypeAndRegion(): void {
    this._sweetAlertHelper.createCustomAlert({
      title: 'Are you sure you want to change the plan type and region of the reservation?',
      text: 'You will not be able to revert this!',
      type: 'warning',
      showCancelButton: true,
    })
      .then((result) => {
        if (result && result.value) {
          if (!this.validateSelectedTrips(this.tripId)) {
            return;
          }
          this.updateReservationPlanTypeAndRegion(this.tripId);
        }
      });
  }

  private validateSelectedTrips(selectedTrips: number): boolean {
    if (selectedTrips) {
      return true;
    }

    this._sweetAlertHelper.createCustomAlert({
      title: 'Attention',
      text: 'You must select at least one trip',
      type: 'warning',
    });

    return false;
  }

  private updateReservationPlanTypeAndRegion(selectedTrips: number): void {
    this.loading.show();
    this.suscriptions.push(
      this.planService.setReservationPlanTypeAndRegion([selectedTrips])
        .finally(() => this.loading.hiden())
        .subscribe({
          next: (response) => this.showSuccessAlert(response.message),
          error: (error) => this._sweetAlertHelper.captureException(error),
        })
    );
  }

  private showSuccessAlert(message: string): void {
    this._sweetAlertHelper.createCustomAlert({
      title: 'Success',
      text: message,
      type: 'success',
    });
    this._reservationService.setUpdateEncounterHistory(this.tripId);
  }

  get showSetPlanTypeAndRegionButton(): boolean {
    return this.encounterData && this.encounterData.showButton;
  }

  ngOnDestroy(): void {
    this.planService.notifyChangeReservationPlanTypeAndRegion(null);
    if (this.suscriptions) {
      this.suscriptions.forEach((subscription: Subscription) => {
        subscription.unsubscribe();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/encounter-history/encounter-history.component.ts